import { CustomLoading } from 'common'

export const ReportViewer = ({ useFetchInit }) => {

    const { FetchData } = useFetchInit

    const { fetchBankMovementsReport } = FetchData
    const { bankMovementsReportBase64, loadingFetchBankMovementsReport } = fetchBankMovementsReport
    const { docName, docBase64 } = bankMovementsReportBase64

    return (
        <>
            {loadingFetchBankMovementsReport && (<CustomLoading />)}
            {(!loadingFetchBankMovementsReport && docBase64) && (
                <iframe
                    src={docBase64}
                    width="100%"
                    height="700"
                    style={{ border: "none" }}
                    title={docName}
                />
            )}
        </>
    )
}
